const IS_PRODUCTION = true

export const USER_FE_URL = import.meta.env.VITE_USER_FE_URL || (IS_PRODUCTION ? "https://platform.gobla.ai/" : "https://beta.platform.gobla.ai/")

// Mobla.ai company-facing frontend (hosts the /auto-login page)
 export const MOBLA_FE_URL = import.meta.env.VITE_MOBLA_FE_URL || (IS_PRODUCTION ? "https://platform.mobla.ai/" : "https://beta.platform.mobla.ai/")
// export const MOBLA_FE_URL = "http://localhost:5173/"

export const USER_BACKEND_URL = USER_FE_URL + "live/api/"

export const IMG_URL = USER_BACKEND_URL + "uploads/"

const config = {

}

export default config;